export enum CurrencyType {
  EUR = 'EUR',
  GBP = 'GBP',
}

export enum FormatType {
  DEFAULT = 'DEFAULT',
  SYMBOL = 'SYMBOL',
  SYMBOL_SUP = 'SYMBOL_SUP',
  TAX_SUP = 'TAX_SUP',
}

export enum VatType {
  EXCLUDED = 'EXCLUDED',
  INCLUDED = 'INCLUDED',
  NONE = 'NONE',
}

export interface TranslationsType {
  excludedVAT?: string;
  excludedVATAbbr?: string;
  free?: string;
  includedVAT?: string;
  includedVATAbbr?: string;
}

export interface PricePropsType
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLSpanElement>,
    HTMLSpanElement
  > {
  // locale: 'fr-FR' | 'en-GB' | 'it-IT' | 'es-ES' | 'de-DE'; // TODO, see with UX if we should implement this
  currency?: CurrencyType;
  format?: FormatType;
  maximumFractionDigits?: number;
  minimumFractionDigits?: number;
  obsolete?: boolean;
  translations?: TranslationsType;
  value: number;
  vat?: VatType;
  forcedLocale?: string;
}

export interface VatPropsType {
  vatAbbr?: string;
  vatText?: string;
}

export interface SmartVatPropsType {
  translations: TranslationsType;
  vat: VatType;
}
